export const isAuthenticated = () => getToken();
export const getToken = () => localStorage.getItem("mpt-Token");
export const login = data => { localStorage.setItem("mpt-Token", data.token)}
export const logout = () => { localStorage.clear() }
